import { notification } from 'antd';
import React from 'react';

export const useNotification = () => {
    const [api, contextHolderr] = notification.useNotification();

    const showNotification = (
        type: 'info' | 'success' | 'error' | 'warning',
        message: string,
        description: string,
    ) => {
        api[type]({
            message,
            description,
            placement: 'topRight',
            duration: 5,
        });
    };

    return { showNotification, contextHolderr };
};

export default useNotification;
